<template>
  <div class="modal fade in show" tabindex="-1" role="dialog">
    <form v-on:submit.prevent="setNewStatus">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="$parent.showChangeManagerDialog = false"
              aria-label="Закрыть"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 v-if="hasManager" class="modal-title">
              Изменение менеджера сопровождения
            </h4>
            <h4 v-else class="modal-title">
              Назначение менеджера сопровождения
            </h4>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger"
              role="alert"
              v-for="err in saveErrors"
            >
              {{ err }}
            </div>

            <div class="form-group">
              <label v-if="hasManager">Изменить менеджера</label>
              <label v-else>Назначить менеджера</label>
              <select class="form-control" v-model="statusData.UF_MANAGER_ID">
                <!-- <option value="" >{{UF_MANAGER_ID}}</option> -->
                <option
                  v-for="item in managerList"
                  v-bind:key="item.ID"
                  v-bind:value="item.ID"
                  v-text="item.FULL_NAME"
                ></option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="$parent.showChangeManagerDialog = false"
            >
              Отмена
            </button>

            <button
              type="submit"
              class="btn btn-primary"
              v-if="showSubmitBtn"
              :disabled="!isReadyToSend"
            >
              <template v-if="hasManager" style="cursor: pointer"
                >Изменить менеджера
              </template>
              <template v-else style="cursor: pointer"
                >Назначить менеджера</template
              >
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </form>
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapGetters } from "vuex";
import { ProjectsService } from "@/common/api.service";

export default {
  data() {
    return {
      saveErrors: [],
      hasManager: "",
      statusData: {
        UF_MANAGER_ID: ""
      },
      // UF_MANAGER_ID: '',
      showSubmitBtn: false,
      step: 1
    };
  },
  created() {
    this.hasManager = this.project.UF_MANAGER_OSP > 0;
    this.statusData.UF_MANAGER_ID = this.project.UF_MANAGER_OSP;
  },
  asyncComputed: {
    async managerList() {
      let list = [];
      this.showSubmitBtn = false;
      await ProjectsService.getListManagerDSPProject().then(({ data }) => {
        console.log(data);
        data.forEach(function(d) {
          list.push({
            ID: d.ID,
            FULL_NAME: d.FULL_NAME
          });
        });
      }, this);
      this.showSubmitBtn = true;
      return list;
    }
  },
  computed: {
    isReadyToSend() {
      return true;
    },
    ...mapGetters(["project"])
  },
  methods: {
    findName(list, id, r) {
      if (r) {
        return r;
      }

      list.forEach(function(l) {
        if (l.CHILD) {
          r = this.findName(l.CHILD, id, r);
        } else {
          l.ID.forEach(function(item) {
            if (item.ID === id) {
              r = item.NAME;
            }
          });
        }
      }, this);
      return r;
    },
    setNewStatus() {
      this.saveErrors = [];
      ProjectsService.changeManagerDSPProject(this.$parent.project.ID, {
        UF_MANAGER_OSP: this.statusData.UF_MANAGER_ID
      }).then(response => {
        if (response.data.error === false) {
          ProjectsService.getListManagerDSPProject().then(({ data }) => {
            data.forEach(function(d) {
              if (d.ID === this.statusData.UF_MANAGER_ID) {
                this.project.UF_MANAGER_OSP = d.ID;
                this.project.UF_MANAGER_OSP_NAME = d.FULL_NAME;
                this.$parent.showChangeManagerDialog = false;
              }
            }, this);
          }, this);
          //this.$parent.fetchProject(0);
          //this.$router.push({ name: "Projects" });
        } else {
          this.saveErrors = response.data.errorArr;
        }
      }, this);
    }
  },
  name: "ChangeManagerOSP"
};
</script>

<style scoped></style>
